import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useRequestsAPI } from '@innowise-group/core';
import { Modal, modalHoc, ModalProps } from '@innowise-group/mui-kit';

import * as Styled from './request-closing-modal.styles';

interface RequestClosingModalProps {
  id: number;
}

const RequestClosingModal: React.FC<ModalProps & RequestClosingModalProps> = ({ close, id }) => {
  const { t } = useTranslation();
  const { closeRequest } = useRequestsAPI();
  const [isClosing, setIsClosing] = useState(false);

  const closeRequestItem = async () => {
    setIsClosing(true);
    try {
      await closeRequest(id).unwrap();
      close();
    } catch {
      // The interceptor shows the error, the modal stays open to retry
      setIsClosing(false);
    }
  };

  return (
    <Modal.Container size="small">
      <Modal.Header onClose={close}>
        <Styled.ModalTitle>{t('pages.requests.closingModal.requestClosing')}</Styled.ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <Styled.Description>
          {t('pages.requests.closingModal.sureClose')}
          <br />
          {t('pages.requests.closingModal.closingResult')}
        </Styled.Description>
      </Modal.Body>
      <Styled.Footer>
        <Styled.CancelButton onClick={close} variant="outlined">
          {t('buttons.cancel')}
        </Styled.CancelButton>
        <Styled.SubmitButton onClick={closeRequestItem} disabled={isClosing}>
          {t('buttons.closeRequest')}
        </Styled.SubmitButton>
      </Styled.Footer>
    </Modal.Container>
  );
};

export default modalHoc(RequestClosingModal, 'request-closing');
